module.exports = __webpack_public_path__ + "img/invite-email.2cc13295.svg";